import tokens from '@/PrimeVue/customDesignTokens';

export default {
  background: tokens.input.background.color,
  color: tokens.text.colors.default,
  disabledColor: tokens.text.colors.readonly,
  placeholderColor: tokens.text.colors.placeholder,
  border: {
    color: tokens.input.border.colors.default,
    radius: tokens.input.border.radius
  },
  padding: {
    x: '12px',
    y: '6px'
  },
  shadow: tokens.input.shadow.default,
  invalid: {
    border: {
      color: tokens.input.border.colors.error
    },
    ring: {
      shadow: tokens.input.shadow.error,
      offset: tokens.primitive.offset.none
    }
  },
  focus: {
    border: {
      color: tokens.input.border.colors.focus
    },
    ring: {
      shadow: tokens.input.shadow.focus,
      offset: tokens.primitive.offset.none
    }
  },
  hover: {
    border: {
      color: tokens.input.border.colors.default
    }
  }
};